/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { FONT_LINE_HEIGHT_M, Text } from '@veeam/components';

import type { TextProps } from '@veeam/components';

export interface BlankLineProps {
    props?: TextProps;
}

export const BlankLine: React.FC<BlankLineProps> = ({ props = {} }) => (
    <Text {...props} style={{ ...props.style, height: FONT_LINE_HEIGHT_M }}>
        <Text asTag={'br'} />
    </Text>
);
